import React from 'react';

const fmt = (n: number) =>
  '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtHrs = (n: number) => n.toFixed(2);

export interface HoursSummary {
  totalHrs: number;
  billableHrs: number;
}

interface Props {
  cost: number;
  sale: number;
  costLabel?: string;
  taxTag: string;
  hours?: HoursSummary;
  className?: string;
}

/** Shared cascade bar — section headers/footers and group row amounts */
export const TmCascadeSummary: React.FC<Props> = ({
  cost, sale, costLabel = 'Cost', taxTag, hours, className = 'tm-sec-sum',
}) => (
  <span className={className}>
    {hours && (
      <>
        <span className="tm-sum-item">
          <span className="tm-sum-lbl">Timesheet total hrs</span>
          <b>{fmtHrs(hours.totalHrs)}</b>
          <span className="tm-sum-unit">Hrs</span>
        </span>
        <span className="sep" aria-hidden>·</span>
        <span className="tm-sum-item">
          <span className="tm-sum-lbl">Timesheet billable hrs</span>
          <b>{fmtHrs(hours.billableHrs)}</b>
          <span className="tm-sum-unit">Hrs</span>
        </span>
        <span className="sep" aria-hidden>·</span>
      </>
    )}
    <span className="tm-sum-item">
      <span className="tm-sum-lbl">{costLabel}</span>
      <b>{fmt(cost)}</b>
      <span className="tax-tag">{taxTag}</span>
    </span>
    <span className="sep" aria-hidden>·</span>
    <span className="tm-sum-item">
      <span className="tm-sum-lbl">Sale</span>
      <b className="sell">{fmt(sale)}</b>
      <span className="tax-tag">{taxTag}</span>
    </span>
  </span>
);
